import RichTextEditor from "../../common/RichTextEditor";
export default RichTextEditor;
